import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchUserAttributes } from "aws-amplify/auth";
//Include Both Helper File with needed methods


export const getUserDetails = createAsyncThunk("userDetails/getUserDetails", async () => {
    try {
        const response = await fetchUserAttributes();
        const data = {
            firstName : response['custom:firstname'],
            lastName : response['custom:lastname'],
            email : response.email,
            role: response['custom:role']
        }
        return data;
    } catch (error) {
        return error;
    }
});

